<template>
  <div class='alert'>
    <div class='inner'>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Alert'
}
</script>

<style scoped lang='scss'>
.alert {
  display: flex;
  background-color: #212729;
  padding: 1em 1.25em;
  border-radius: 4px;
}
</style>